//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'kuguo-music',
  props: {
    artistName: String,
    artistAvatar: String,
    musicList: Array,
    celebrityHome: {
      type: Boolean,
      default: false
    },
    detailPage: false
  },
  mounted: function mounted() {
    this.$emit('previewStats');
  },
  methods: {
    goToMusic: function goToMusic(e) {
      var url = e.currentTarget.dataset.url;
      this.$emit('gotoMusic', {
        url: url
      });
    }
  }
};